import * as React from 'react';

import {HelpButton} from 'shells/help/help-button';

import {OpenableModals, useOpenableModal} from '../../openable-modals';

export function SourcesPageDescription() {
    const {onOpen} = useOpenableModal(OpenableModals.ATTRIBUTION_ONBOARDING_MODAL);

    return (
        <div className='flex'>
            Identify where your leads come from with sources.
            {/* @ts-expect-error */}
            <HelpButton onClick={onOpen} />
        </div>
    );
}
